import React, { useState, useContext, useEffect } from 'react';
import '../../../../assets/css/screens/admin/dashboard/faq/AdminFaq.css';

import {
  Plus,
  ChevronDown,
  ChevronUp,
  Edit2,
  Trash2,
  X,
  HelpCircle
} from 'lucide-react';

import axios from 'axios';
import AppContext from '../../../../context/AppContext';

const FAQ_TYPES = ['General', 'Worker', 'Customer'];
const FAQ_STATUSES = ['Active', 'Inactive'];

const AdminFAQs = () => {

  const { baseUrl, authToken} = useContext(AppContext);

  const [faqs, setFaqs] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editTarget, setEditTarget] = useState(null);

  const [faq_type, setFaq_type] = useState('General');
  const [status, setStatus] = useState('Active');
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  // create faq
  const createFaq = () => {

    if (!question || !answer) {

      alert('Please fill all fields');
      return;
    }

    setLoading(true);

    const formData = new FormData();

    formData.append('faq_type', faq_type);
    formData.append('question', question);
    formData.append('answer', answer);
    formData.append('status', status);
    // status === 'Active' ? 1 : 0


    axios.post(
      `${baseUrl}/admin/faq`,
      formData,
      {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  }
    )
      .then(() => {
        viewAllFaqs();
        setLoading(false);
        close();
        // alert('FAQ added successfully!');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        alert('Network Error!');
      });
  };
  // view faq
  const viewAllFaqs = () => {
    axios.get(`${baseUrl}/viewallfaq`,
      {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  }
    )
      .then((response) => {
        setFaqs(response.data.faqs);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    viewAllFaqs();
  }, []);
  // update faq
  const updateFaq = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('id', editTarget.id);
    formData.append('faq_type', faq_type);
    formData.append('question', question);
    formData.append('answer', answer);
    formData.append('status', status);
    // status === 'Active' ? 1 : 0
    axios.post(`${baseUrl}/updatefaq`, formData,
      {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
      .then(() => {
        viewAllFaqs();
        setLoading(false);
        close();
        alert('FAQ updated successfully!');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        alert('Network Error!');
      });
  };
  // delete faq
  const deleteFaq = (id) => {
    const formData = new FormData();
    formData.append('id', id);
    axios.post(`${baseUrl}/whadmin/deleteWhFaq`, formData,
      {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  }
    )
      .then(() => {
        viewAllFaqs();
        alert('FAQ deleted successfully!');
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // OPEN ADD MODAL
  const openAdd = () => {
    setFaq_type('General');
    setStatus('Active');
    setQuestion('');
    setAnswer('');
    setEditTarget(null);
    setModal('add');
  };
  // OPEN EDIT MODAL
  const openEdit = (faq) => {
    setEditTarget(faq);
    setFaq_type(faq.faq_type);
    setStatus(faq.status);
    setQuestion(faq.question);
    setAnswer(faq.answer);
    setModal('edit');
  };
  // CLOSE MODAL
  const close = () => {
    setModal(null);
    setEditTarget(null);
  };
  return (
    <div className="afq-page">
      {/* HEADER */}
      <div className="afq-header">
        <div>
          <h2 className="afq-title">FAQs</h2>
          <p className="afq-sub">
            Manage frequently asked questions
          </p>
        </div>
        <button className="afq-add-btn"
          onClick={openAdd}>
          <Plus size={16} />
          Add FAQ
        </button>
      </div>
      {/* FAQ LIST */}
      <div className="afq-list">
        {faqs.map((faq) => (
          <FAQRow
            key={faq.id}
            faq={faq}
            onEdit={openEdit}
            onDelete={deleteFaq}
          />
        ))}
      </div>
      {faqs.length === 0 && (

        <div className="afq-empty">

          <HelpCircle size={40} />

          <p>
            No FAQs added yet.
          </p>

        </div>

      )}
      {/* MODAL */}

      {modal && (
        <div
          className="afq-overlay"
          onClick={close}
        >
          <div
            className="afq-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="afq-modal__header">
              <h5 className="afq-modal__title">
                {
                  modal === 'edit'
                    ? 'Edit FAQ'
                    : 'Add FAQ'
                }
              </h5>
              <button
                className="afq-modal__close"
                onClick={close}
              >
                <X size={18} />
              </button>
            </div>
            <div className="afq-modal__body">
              {/* ROW */}
              <div className="afq-modal__row">
                {/* TYPE */}
                <div className="afq-modal__field">
                  <label className="afq-modal__label">
                    FAQ Type
                  </label>
                  <div className="afq-select-wrap">
                    <select
                      className="afq-select"
                      value={faq_type}
                      onChange={(e) =>
                        setFaq_type(e.target.value)
                      }
                    >
                      {FAQ_TYPES.map((type) => (
                        <option
                          key={type}
                          value={type}
                        >
                          {type}
                        </option>
                      ))}
                    </select>
                    <ChevronDown
                      size={15}
                      className="afq-select-arrow"
                    />
                  </div>
                </div>
                {/* STATUS */}
                <div className="afq-modal__field">
                  <label className="afq-modal__label">
                    Status
                  </label>
                  <div className="afq-select-wrap">
                    <select
                      className="afq-select"
                      value={status}
                      onChange={(e) =>
                        setStatus(e.target.value)
                      }
                    >
                      {FAQ_STATUSES.map((statusItem) => (
                        <option
                          key={statusItem}
                          value={statusItem}
                        >
                          {statusItem}
                        </option>
                      ))}
                    </select>
                    <ChevronDown
                      size={15}
                      className="afq-select-arrow"
                    />
                  </div>
                </div>
              </div>
              {/* QUESTION */}
              <div className="afq-modal__field">
                <label className="afq-modal__label">
                  Question
                </label>
                <input
                  className="afq-input"
                  type="text"
                  placeholder="Enter the question"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)
                  }
                />
              </div>
              {/* ANSWER */}
              <div className="afq-modal__field">
                <label className="afq-modal__label">
                  Answer
                </label>
                <textarea
                  className="afq-textarea"
                  rows={5}
                  placeholder="Enter the answer..."
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)
                  }
                />
              </div>
              {/* SAVE BUTTON */}
              <button
                className="afq-save-btn"
                onClick={
                  modal === 'edit'
                    ? updateFaq
                    : createFaq
                }
                disabled={loading}
              >
                {
                  loading
                    ? 'Please Wait...'
                    : modal === 'edit'
                      ? 'Save Changes'
                      : 'Add FAQ'
                }
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
// FAQ ROW COMPONENT
const FAQRow = ({
  faq,
  onEdit,
  onDelete
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`afq-row${open ? ' afq-row--open' : ''}`}
    >
      <button
        className="afq-row__trigger"
        onClick={() => setOpen(!open)}
      >
        <div className="afq-row__trigger-left">
          <div className="afq-row__badges">
            <span className="afq-badge afq-badge--type">
              {faq.faq_type}
            </span>
            <span
              className={`afq-badge afq-badge--status ${faq.status
                ? 'afq-badge--active'
                : 'afq-badge--inactive'
                }`}
            >
              {faq.status}
            </span>
          </div>
          <h5 className="afq-row__question">
            {faq.question}
          </h5>
        </div>
        {
          open
            ? (
              <ChevronUp
                size={18}
                className="afq-row__chevron"
              />
            )
            : (
              <ChevronDown
                size={18}
                className="afq-row__chevron" />
            )}
      </button>
      {open && (
        <div className="afq-row__body">
          <p className="afq-row__answer">
            {faq.answer}
          </p>
          <div className="afq-row__actions">
            <button
              className="afq-edit-btn"
              onClick={() => onEdit(faq)}>
              <Edit2 size={14} />
              Edit</button>
            <button
              className="afq-delete-btn"
              onClick={() => onDelete(faq.id)}>
              <Trash2 size={14} />
              Delete</button>
          </div>  </div>
      )}</div>
  );
};

export default AdminFAQs;